<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/99C19T/tc-custom/9781426839436.jpg?1740433782371" alt="This image is the cover for the book Smokin' Six-Shooter, Whitehorse, Montana: The Corbetts"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Smokin' Six-Shooter, Whitehorse, Montana: The Corbetts
      </h1>
      <p class="bookDescription body article font2">
        <b>A woman investigating a decades-old murder partners up with a sexy cowboy in this romantic suspense from a <i>New York Times</i>–bestselling author.</b><br/><br/>Russell Corbett was all cowboy and wasn’t about to let a lady lasso him! But Dulcie Hughes had him tied up in knots from the moment she nearly collided with his combine. She rode into town with her fancy rental car and city clothes to claim her secret inheritance. And neither tall tale nor handsome rancher would deter her from exposing a years-old cover-up at the Beaumont property. She expected to find answers, not fall in love. But like the threatening thunderhead on the horizon, the truth would come fast and fierce, and there would be no escaping the consequences.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        B. J. Daniels
      </h2>
      
      <p class="authorDescription body article">New York Times and USA Today bestselling author B.J. Daniels lives in Montana with her husband, Parker, and two springer spaniels. When not writing, she quilts, boats and always has a book or two to read. Contact her at <a href="http://www.bjdaniels.com/">www.bjdaniels.com</a>, on Facebook at B.J. Daniels or through her reader group the B.J. Daniels' Big Sky Darlings, and on twitter at bjdanielsauthor.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7de3454e